import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { requestLoginModal } from '@corefront/redux-aba';
import { isLoggedInSelector } from '../redux/reducers/app/params';

export const useAuthCallback = (onClick = undefined) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isLoggedInSelector);

  return useCallback(
    (event, ...args) => {
      /**
       * If parent decide to prevent default behavior
       * do not run default component logic on click event
       */
      if (event && event.isDefaultPrevented()) return;

      if (isLoggedIn) {
        if (typeof onClick === 'function') {
          onClick(event, ...args);
        }

        return;
      }

      if (event) {
        // Do not allow to follow by link
        event.preventDefault();
      }

      // and request show login modals
      dispatch(requestLoginModal());
    },
    [dispatch, isLoggedIn, onClick]
  );
};
